import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode, Mousewheel } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const BeautySlider1 = () => {
  const { salonatHome_Sub_cat } = useSelector((store) => store.subCategory);
  const navigate = useNavigate();

  return (
    <div className="pt-4" style={{ backgroundColor: "#f5f6fb" }}>
      {/* Header Section - Exact same as GenericSalon */}
      <div className="container-fluid px-3 px-md-4 mb-4">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex flex-column">
            <h2 className="fw-bold text-dark mb-2 fs-4">Beauty Essentials</h2>
            <div
              className="bg-primary rounded"
              style={{ width: "50px", height: "3px" }}
            ></div>
          </div>
        </div>
      </div>

      {/* Desktop Slider Section */}
      <div
        className="container-fluid px-0 d-none d-md-block"
        style={{ backgroundColor: "#f5f6fb" }}
      >
        <Swiper
          slidesPerView={"auto"}
          spaceBetween={16}
          freeMode={true}
          modules={[FreeMode, Mousewheel, Autoplay]}
          loop={false}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          breakpoints={{
            320: {
              slidesPerView: 1.3,
              spaceBetween: 12,
            },
            480: {
              slidesPerView: 1.8,
              spaceBetween: 14,
            },
            640: {
              slidesPerView: 2.3,
              spaceBetween: 16,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 16,
            },
            1024: {
              slidesPerView: 3.5,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 4.2,
              spaceBetween: 20,
            },
          }}
          className="px-3 px-md-4"
        >
          {salonatHome_Sub_cat.map((data, index) => (
            <SwiperSlide
              key={`beauty-${data._id || index}`}
              style={{ width: "auto" }}
            >
              <div
                className="d-flex flex-column h-100 bg-white rounded-3 overflow-hidden"
                onClick={() => navigate(`/salon-at-home/${data.name}`)}
                style={{
                  cursor: "pointer",
                  transition: "transform 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 12px rgba(0,0,0,0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 1px 3px rgba(0,0,0,0.1)";
                }}
              >
                {/* Image Container - Exact same as GenericSalon */}
                <div
                  className="position-relative overflow-hidden"
                  style={{ height: "180px", flex: "0 0 auto" }}
                >
                  <img
                    src={data.desktopImage}
                    alt={data.name}
                    className="w-100 h-100 object-fit-cover rounded-3"
                    onError={(e) => {
                      e.target.src =
                        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 400 300'%3E%3Crect width='400' height='300' fill='%23f8f9fa'/%3E%3Ctext x='50%25' y='50%25' font-family='Arial' font-size='18' fill='%236c757d' text-anchor='middle' dy='.3em'%3EBeauty Service%3C/text%3E%3C/svg%3E";
                    }}
                  />

                  {/* Gradient Overlay - Exact same as GenericSalon */}
                  <div
                    className="position-absolute top-0 start-0 w-100 h-100"
                    style={{
                      background:
                        "linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.1) 100%)",
                    }}
                  ></div>

                  {/* Rating Overlay - Same as GenericSalon but with fixed text */}
                  <div className="position-absolute bottom-0 start-0 m-2">
                    <div
                      className="d-flex align-items-center bg-dark bg-opacity-85 py-1 rounded-pill"
                      style={{ width: "3vw" }}
                    >
                      <i className="bi bi-heart-fill text-warning me-1 small"></i>
                      <span className="text-white small fw-semibold w-100 h-100 d-flex justify-content-center ps-3">
                        4.8
                      </span>
                    </div>
                  </div>
                </div>

                {/* Service Info - Exact same styling as GenericSalon */}
                <div className="p-3 d-flex flex-column flex-grow-1">
                  <h6 className="fw-semibold mb-1 text-truncate fs-6 text-dark">
                    {data.name}
                  </h6>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Mobile Version - Fixed 60px width */}
      <div
        className="container-fluid px-0 d-block d-md-none"
        style={{ backgroundColor: "#f5f6fb" }}
      >
        <Swiper
          slidesPerView={"auto"}
          spaceBetween={12}
          freeMode={true}
          modules={[FreeMode, Mousewheel, Autoplay]}
          loop={false}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          className="px-3"
        >
          {salonatHome_Sub_cat.map((data, index) => (
            <SwiperSlide
              key={`beauty-mobile-${data._id || index}`}
              style={{ width: "80px" }} // Fixed 60px width for mobile
            >
              <div
                className="d-flex flex-column h-100 bg-white rounded-3 overflow-hidden"
                onClick={() => navigate(`/salon-at-home/${data.name}`)}
                style={{
                  cursor: "pointer",
                  transition: "transform 0.2s ease",
                  width: "80px", // Ensure container also has 60px width
                }}
              >
                {/* Image Container - Adjusted for mobile */}
                <div
                  className="position-relative overflow-hidden"
                  style={{ height: "80px", flex: "0 0 auto" }} // Square 60px image
                >
                  <img
                    src={data.desktopImage}
                    alt={data.name}
                    className="w-100 h-100 object-fit-cover rounded-3"
                    onError={(e) => {
                      e.target.src =
                        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 400 300'%3E%3Crect width='400' height='300' fill='%23f8f9fa'/%3E%3Ctext x='50%25' y='50%25' font-family='Arial' font-size='18' fill='%236c757d' text-anchor='middle' dy='.3em'%3EBeauty Service%3C/text%3E%3C/svg%3E";
                    }}
                  />

                  {/* Gradient Overlay */}
                  <div
                    className="position-absolute top-0 start-0 w-100 h-100"
                    style={{
                      background:
                        "linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.1) 100%)",
                    }}
                  ></div>

                  {/* Rating Overlay - Smaller for mobile */}
                  <div className="position-absolute bottom-0 start-0 m-1">
                    <div
                      className="d-flex align-items-center bg-dark bg-opacity-85 py-0 rounded-pill"
                      style={{ width: "24px" }}
                    >
                      <i className="bi bi-heart-fill text-warning me-0" style={{ fontSize: "8px" }}></i>
                      <span className="text-white fw-semibold" style={{ fontSize: "8px" }}>
                        4.8
                      </span>
                    </div>
                  </div>
                </div>

                {/* Service Info - Adjusted for mobile */}
                <div className="p-1 d-flex flex-column flex-grow-1 text-center">
                  <h6 
                    className="fw-semibold mb-0 text-truncate" 
                    style={{ 
                      fontSize: "10px",
                      lineHeight: "1.2"
                    }}
                  >
                    {data.name}
                  </h6>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default BeautySlider1;